import { useEffect, useState } from "react";
import PieGraph from "../svg-graphs/PieGraph";
import { getPopularMenu } from "../../utils/dataFetch";
import ResponsiveTable from "../svg-graphs/ResponsiveTable";

export default function PopularMenu({ startDate, endDate }) {
    const [error, setError] = useState("");
    const [popularMenu, setPopularMenu] = useState([]);

    const [showTable, setShowTable] = useState(false);
    const toggleTable = () => setShowTable(!showTable);

    const [showModalTable, setShowModalTable] = useState(false);

    useEffect(() => {
        const fetchPopularMenu = async () => {
            try {
                const tempStart = new Date(startDate);
                tempStart.setHours(0, 0, 0, 0);
                const tempEnd = new Date(endDate);
                tempEnd.setHours(23, 59, 59, 999);
                const result = await getPopularMenu(tempStart.toISOString(), tempEnd.toISOString());
                setPopularMenu(result);
            } catch (error) {
                setError("Помилка завантаження даних!");
            }
        };

        fetchPopularMenu(startDate, endDate);
    }, [startDate, endDate]);

    function sortAndGroup(data) {
        // Групуємо елементи за parent_name
        const groupedData = data.reduce((acc, item) => {
            const parentName = item.parent_name;
            if (!acc[parentName]) {
                acc[parentName] = [];
            }
            acc[parentName].push({ ...item, styles: "text-left align-middle fw-normal" });
            return acc;
        }, {});

        const sortedResult = [];
        const sortedParentNames = Object.keys(groupedData).sort();

        sortedParentNames.forEach((parentName) => {
            // Сортуємо елементи всередині папки за значенням values[0]
            const sortedGroupItems = groupedData[parentName].sort((a, b) => b.values[0] - a.values[0]);

            // Обчислюємо суми для values[0] та values[1]
            const totalValues = sortedGroupItems.reduce(
                (sum, item) => {
                    sum[0] += item.values[0];
                    sum[1] += item.values[1];
                    return sum;
                },
                [0, 0]
            );
            const parentId = sortedGroupItems[0].parent_id;

            // Додаємо Папку з обчисленими сумами
            sortedResult.push({
                id: "pid" + parentId,
                label: parentName,
                parent_name: parentName,
                values: totalValues,
                valueStyles: "text-center align-middle fw-bold"
            });
            sortedResult.push(...sortedGroupItems);
        });

        return sortedResult;
    }

    return (
        <div className="col-12 dashboard--item">
            <div className="dashboard--item--container p-3">
                <h5 className="text-center fw-bold">Популярні страви</h5>
                {error && <div className="alert alert-danger rounded-5 m-auto">{error}</div>}
                {!error && popularMenu.length > 0 ? (
                    <>
                        <div className="mt-3">
                            <PieGraph inputData={popularMenu} legendLabels={["Кількість"]} rowLabel={"Назва"} />
                            {/* Table data */}
                            <div className="d-flex justify-content-center">
                                <button className="btn btn-sm main--button mt-3 me-1" onClick={toggleTable}>
                                    {showTable ? "Сховати" : "Показати топ 15"}
                                </button>
                                <button className="mt-3 btn btn-sm main--button ms-1" onClick={() => setShowModalTable(true)}>
                                    Всі товари
                                </button>
                            </div>
                            {showTable && (
                                <div className="mt-3">
                                    <ResponsiveTable
                                        data={popularMenu.sort((a, b) => b.values[0] - a.values[0]).slice(0, 15)}
                                        headLabels={["Кількість", "Сума"]}
                                        rowLabel={"Назва"}
                                    />
                                </div>
                            )}
                            {showTable && popularMenu.length > 10 && (
                                <div className="d-flex justify-content-center mt-3">
                                    <button className="btn btn-sm main--button" onClick={toggleTable}>
                                        Сховати
                                    </button>
                                </div>
                            )}

                            {showModalTable && (
                                <>
                                    <div className="modal--backdrop fade show"></div>
                                    <div className="modal show" style={{ display: "block" }} tabIndex="-1">
                                        <div className="modal-dialog">
                                            <div className="modal-content rounded-5">
                                                <div className="modal-header">
                                                    <h5 className="modal-title ms-0">Всі товари</h5>
                                                    <button type="button" className="btn-close me-0" onClick={() => setShowModalTable(false)}></button>
                                                </div>
                                                <div className="modal-body p-0">
                                                    <ResponsiveTable data={sortAndGroup(popularMenu)} headLabels={["Кількість", "Сума"]} rowLabel={"Назва"} />
                                                </div>

                                                <div className="modal-footer">
                                                    <button type="button" className="btn btn-sm main--button" onClick={() => setShowModalTable(false)}>
                                                        Закрити
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </>
                ) : (
                    <h5 className="text-center mt-3">Дані відсутні!</h5>
                )}
            </div>
        </div>
    );
}
